module.exports = __webpack_public_path__ + "media/bootstrap-icons/telephone-outbound-29bc5404.svg";